"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTable = exports.StyledProductsTableContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const table_1 = require("../../../../../common/table");
exports.StyledProductsTableContainer = styled_components_1.default.div `
  grid-area: body;
  background-color: #fff;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  overflow: hidden;
`;
exports.StyledTable = (0, styled_components_1.default)(table_1.Table) `
  tbody td:not(:first-of-type) {
    padding-left: 1rem !important;
  }
`;
